import React from "react";
import { Track, Thumb } from "./Switch.styles";
import type { SwitchProps } from "./Switch.types";

/**
 * Toggle switch — stateless. Parent owns `value`. Renders a `<button
 * role="switch">` with `aria-checked` for screen readers; click toggles.
 */
export const Switch: React.FC<SwitchProps> = ({
  value,
  onChange,
  size = "sm",
  disabled = false,
  ariaLabel,
  ariaDescribedBy,
  id,
  className,
}) => (
  <Track
    type="button"
    role="switch"
    id={id}
    aria-checked={value}
    aria-label={ariaLabel}
    aria-describedby={ariaDescribedBy}
    disabled={disabled}
    onClick={() => onChange(!value)}
    $size={size}
    $on={value}
    $disabled={disabled}
    className={className}
  >
    <Thumb $size={size} $on={value} aria-hidden />
  </Track>
);

export default Switch;
